module.exports = __webpack_public_path__ + "img/icon_yaopin.a74fdf85.png";